/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BarbarianFuryGameModuleConfig} from "./BarbarianFuryGameModuleConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {BarbarianFurySoundConfig} from './BarbarianFurySoundConfig';
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {BarbarianWinFieldController} from "./winpresentation/BarbarianWinFieldController";

export class BarbarianFury extends SlotGame {
    private _mode: string = "";

    constructor() {
        super(BarbarianFuryGameModuleConfig.instance);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L4",
                    "L1",
                    "L1",
                    "L2",
                    "L2",
                    "L3"
                ],
                [
                    "L2",
                    "L2",
                    "L1",
                    "L1",
                    "M3",
                    "M3"
                ],
                [
                    "M2",
                    "M2",
                    "L4",
                    "L4",
                    "L2",
                    "L2"
                ],
                [
                    "L1",
                    "L1",
                    "M1",
                    "M1",
                    "M1",
                    "M1"
                ],
                [
                    "L4",
                    "L3",
                    "L3",
                    "L5",
                    "L2",
                    "L2"
                ]
            ],
            "evaluatedArea": [
                [
                    "L1",
                    "L1",
                    "L2",
                    "L2"
                ],
                [
                    "L2",
                    "L1",
                    "L1",
                    "M3"
                ],
                [
                    "M2",
                    "L4",
                    "L4",
                    "L2"
                ],
                [
                    "L1",
                    "M1",
                    "M1",
                    "M1"
                ],
                [
                    "L3",
                    "L3",
                    "L5",
                    "L2"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "activeStackedSymbol": "",
            "stackedSpinTriggered": false,
            "initialStackOverlay": [
                false,
                false,
                false,
                false,
                false
            ],
            "stackOverlay": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "overlayWilds": [
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "doScatterNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L5",
                    "L3",
                    "L3",
                    "L4"
                ],
                [
                    "L4",
                    "L5",
                    "L5",
                    "L4"
                ],
                [
                    "L4",
                    "L3",
                    "M2",
                    "M2"
                ],
                [
                    "L3",
                    "S",
                    "L4",
                    "L5"
                ],
                [
                    "L5",
                    "S",
                    "L5",
                    "L4"
                ]
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "stackedModeSymbolInWin": [
                false,
                false,
                false,
                false,
                false
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "multiplierBeforeSpin": 1,
            "stackedSpinTease": false,
            "wildMultipliers": [
                0,
                0,
                0,
                0,
                0
            ],
            "overlayWildInRespin": [
                false,
                false,
                false,
                false,
                false
            ],
            "showWinDirectly": false,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 70
                }
            ],
            "featureBet": false,
            "wasFeatureBuy": false
        };
    }

    public start(): Promise<NolimitPlugin> {
        return super.start().then((value: NolimitPlugin) => {
            let duration: number = SoundConfig.instance.START_GAME_AMBIANCE_CROSS_FADE_DURATION != null ? SoundConfig.instance.START_GAME_AMBIANCE_CROSS_FADE_DURATION : 1000;
            if (this._mode.indexOf("FREESPIN") !== -1) {
                SlotGame.sound.playAmbience(BarbarianFurySoundConfig.instance.FREE_GAME_AMBIANCE, 0);
            } else if (SoundConfig.instance.MAIN_GAME_AMBIANCE) {
                SlotGame.sound.playAmbience(SoundConfig.instance.MAIN_GAME_AMBIANCE, duration);
            }

            return value;
        });
    }

    protected onInitDataParsed(data: ParsedInitData): void {
        super.onInitDataParsed(data);
        this._mode = data.mode;
    }

    protected createWinFieldController(): BarbarianWinFieldController {
        return new BarbarianWinFieldController();
    }

    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (BarbarianFury.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });

    }
}